export const PROVIDER_COHORTS_TAG_TYPE = 'ProviderCohorts' as const;
export const ALL_COHORTS_ID = 'ALL' as const;
